// extracted by mini-css-extract-plugin
export default {"main":"VerifyEmail_main__g6ruF","h1":"VerifyEmail_h1__NLH8a","btnWrapper":"VerifyEmail_btnWrapper__85eqg"};